import { createUseStyles } from 'react-jss'
import { darkGrey, mediumGrey } from '../../../../styles/const/colors'
import { EXPORT_CHART_ICON_ID } from '../constants'
import { zIndex5 } from '../../../../styles/const/common'

const useStyles = createUseStyles({
  sectionContainer: {
    padding: '30px 20px',
    margin: 0,
    position: 'relative', // relative to position absolutely download icon
    [`& #${EXPORT_CHART_ICON_ID}.pdf-hidden`]: {
      display: 'none'
    }
  },
  downloadIcon: {
    position: 'absolute',
    top: 32,
    right: 28,
    color: darkGrey,
    cursor: 'pointer',
    zIndex: zIndex5
  },
  headingContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: 14,
    paddingRight: 35 // to avoid overlap with download icon
  },
  title: {
    fontSize: 17,
    fontWeight: 700,
    display: 'flex',
    alignItems: 'center',
    gap: 5
  },
  value: {
    fontWeight: 700,
    fontSize: 27,
    marginTop: 10
  },
  valueDescription: {
    fontSize: 17,
    fontWeight: 400,
    color: mediumGrey
  }
})

export default useStyles
